import { queryOptions, useQuery } from '@tanstack/react-query';

import { helpCenterApi } from '../api/help-center-api';

import { helpCenterKeys } from './help-center-keys';

export function helpArticleQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: helpCenterKeys.articleDetail(storeId, id),
    queryFn: () => helpCenterApi.getArticle(storeId, id),
  });
}

export function useHelpArticle(storeId: string, id: string) {
  return useQuery(helpArticleQueryOptions(storeId, id));
}
